var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBlockCircleLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_4621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.375C4.34111 1.375 1.375 4.34111 1.375 8C1.375 9.67085 1.99311 11.1967 3.01382 12.3623L12.4611 3.1021C11.2836 2.02885 9.71844 1.375 8 1.375ZM12.9862 3.63767L3.53885 12.8979C4.71642 13.9712 6.28156 14.625 8 14.625C11.6589 14.625 14.625 11.6589 14.625 8C14.625 6.32915 14.0069 4.80331 12.9862 3.63767ZM0.625 8C0.625 3.9269 3.9269 0.625 8 0.625C10.063 0.625 11.9287 1.47255 13.2668 2.83748C14.5705 4.16737 15.375 5.99011 15.375 8C15.375 12.0731 12.0731 15.375 8 15.375C5.937 15.375 4.07128 14.5275 2.73321 13.1625C1.4295 11.8326 0.625 10.0099 0.625 8Z",
    fill: "#FF3737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_4621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockCircleLined);
export default __webpack_public_path__ + "static/media/ic_block_circle_lined.b7b4d3b40a0d5fad17dffd27ecd97e39.svg";
export { ForwardRef as ReactComponent };